
import { defineComponent, reactive, toRefs } from 'vue'
import { useStore } from 'vuex'
import { Toast, Dialog } from 'vant'
import request from '@/utils/hbRequest.js'
export default defineComponent({
  name: 'Info',
  setup() {
    const store = useStore()
    const state = reactive({
      allAlign: null,
      show: false,
      currentDetail: {
        id: null,
        activityId: null,
        address: null,
        city: null,
        createTime: null,
        district: null,
        identityCard: null,
        province: null,
        salesmanId: null,
        servingCount: null,
        servingId: null,
        servingName: null,
        userName: null,
        phone: null,
        servingPriceSum: null
      },
      detail: {
        visitorCount: 0,
        viewCount: 0,
        registrationCount: 0,
        servingRegistrationList: []
      }
    })

    const getData = async () => {
      const id = store.state.userId
      const res = await request.get(`/spread/salesman/${id}/detail`)
      if (res.code !== 0) {
        return Toast(res.message)
      }
      state.detail = res.data
    }
    getData()

    const onClickCell = (e) => {
      state.show = true
      state.currentDetail = e.row
      console.log(e)
    }

    const delUser = () => {
      Dialog.confirm({
        title: '提示',
        message: '确定要删除该登记信息?'
      }).then(async () => {
        const id = state.currentDetail.id
        const res = await request.delete(
          `/spread/serving/registration/${id}/delete`
        )
        if (res.code !== 0) {
          return Toast(res.message)
        }
        state.show = false
        Toast('删除成功')
        getData()
      })
    }

    const callPhone = (phone) => {
      window.location.href = 'tel:' + phone
    }

    return {
      ...toRefs(state),
      onClickCell,
      delUser,
      callPhone
    }
  }
})
